<template>
  <div class="template-library-root flex flex-col h-full">
    <invitation-notifications v-if="currentUser.id" />
    <OnboardingV3BackArrow />
    <SearchSection />
    <div class="publish hidden lg:inline-block">
      <aha-antd-button
        v-aha-emit-action
        v-blur-on-click
        class="templates-publish-my-own"
        name="publish_presentation_template_btn"
        variant="secondary"
        @click="handleOpenModalPublishPresentations"
      >
        <span>{{ $i18nPresenter.t('Publish my own') }}</span>
      </aha-antd-button>
    </div>
    <div class="template-library-content">
      <div class="template-library-content-wrapper grid-cols-12">
        <TemplateNavbar
          :categories="categories"
          :hideActiveCategory="!!$route.query.q"
          :selectedCategoryLabel="selectedCategoryLabel"
          :activeTab="activeCategoryId"
          class="template-library-sidebar"
          @onChange="handleCategoryChange"
        />
        <div class="template-library-main">
          <div class="result--section">
            <!-- Categories Result -->
            <CategoryResultSection
              v-if="isCategorySectionActive"
              :isLoading="isLoadingCategoryDetail"
              :categorySelected="categorySelected"
              :title="selectedCategoryLabel"
              @clearSearch="clearSearch"
            />
            <div v-else>
              <!-- Search result -->
              <SearchResultSection
                v-if="isSearchSectionActive"
                :filteredPresentations="filteredPresentations"
                :noResult="noResult"
                :isSearching="isSearching"
                :searchText="searchText"
                :isLoadmore="isLoadmore"
                :isLoadingMore="isLoadingMore"
                @loadMore="loadMore"
              />
              <!-- Normal browse, no categories and search -->
              <div
                v-if="isDiscoverSectionActive"
                class="section-discover"
              >
                <div class="mb-4 hidden xl:flex">
                  <h2 class="capitalize text-base xxl:text-xl">
                    {{ $i18nPresenter.t('Discover') }}
                  </h2>
                </div>
                <div
                  v-if="templateCategories
                    && templateCategories.length > 0
                    && filteredPresentations.length === 0
                    && !noResult
                  "
                  class="templates"
                >
                  <div>
                    <div
                      class="template-container_item mb-8 slider __slider"
                    >
                      <TemplateSliderSkeleton v-if="!featuredTemplatesByCategories.length" />
                      <div class="container-template-category">
                        <div class="grid-card-row">
                          <TemplateCard
                            v-for="presentation in featuredTemplatesByCategories"
                            :key="presentation.id"
                            v-aha-emit-action="{ template_id: presentation.id }"
                            :presentation="presentation"
                            :where="'Discover'"
                            :version="'template-card-v2'"
                            class="template-category-item template-library w-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="!canUseNewComunityTemplate"
                    class="template-container_item pt-8 mb-4 slider __slider"
                  >
                    <h2 class="title-template-type">
                      <span class="icon-template-type">
                        <img :src="require('@/assets/images/icon/star.svg')">
                      </span>{{ $i18nPresenter.t("Staff Choice") }}
                    </h2>
                    <div
                      v-aha-emit-action="{ swipe_direction: 'prev' }"
                      name="template_swiper_btn"
                      :class="
                        [`slider __prev --ahaslides-pick`,{hidden: isLoadingTemplateAdminPicked}]"
                      @click="trackSliderBtn('Back')"
                    >
                      <aha-icon
                        width="12"
                        height="18"
                        viewBox="0 0 8 14"
                        name="arrow-no-tail"
                        class="transform rotate-180"
                      />
                    </div>
                    <div
                      v-aha-emit-action="{ swipe_direction: 'next' }"
                      name="template_swiper_btn"
                      :class="
                        [
                          `slider __next --ahaslides-pick`,
                          {
                            hidden: isLoadingTemplateAdminPicked
                          }
                        ]"
                      @click="trackSliderBtn('Next')"
                    >
                      <aha-icon
                        width="12"
                        height="18"
                        viewBox="0 0 8 14"
                        name="arrow-no-tail"
                      />
                    </div>
                    <TemplateSliderSkeleton v-if="isLoadingTemplateAdminPicked" />
                    <swiper
                      v-if="!isLoadingTemplateAdminPicked
                        && templateAdminPicked.length > 0"
                      :ref="`swiper-main`"
                      class="swiper-main"
                      :autoUpdate="true"
                      :options="getSliderOptions({
                        folderId: 'ahaslides-pick',
                        folderName: 'AhaSlides Pick',
                      })"
                    >
                      <swiper-slide
                        v-for="presentation in templateAdminPicked"
                        :key="`template-admin-pick-${presentation.id}`"
                        class="swiper-slide__template-library h-full"
                      >
                        <TemplateCard
                          v-aha-emit-action="{ template_id: presentation.id }"
                          name="template-card"
                          :presentation="presentation"
                          class="template-library"
                          where="AhaSlides Pick"
                          templateLocation="template library"
                        />
                      </swiper-slide>
                    </swiper>
                  </div>
                  <div v-if="isLoadingTemplates && !templateCategories" class="mt-10 mb-24">
                    <TemplateSliderSkeleton />
                  </div>
                  <div>
                    <div
                      v-for="category in templateCommunityV2"
                      :key="category.categoryId"
                      class="template-container_item pt-8 mb-4 slider __slider"
                    >
                      <div class="title-template-category-container flex">
                        <h2 class="title-template-type title-item-template-category mb-4">
                          {{ $i18nPresenter.t(category.categoryName) }}
                        </h2>
                        <span
                          v-aha-emit-action="{ category_id: category.categoryId }"
                          name="template_see_all"
                          class="title-template-see-all"
                          @click="handleCategoryChange({
                            id: category.categoryId,
                            label: category.categoryName,
                          })"
                        >
                          {{ $i18nPresenter.t('See all') }}
                        </span>
                      </div>
                      <TemplateSliderSkeleton v-if="isLoadingTemplates" />
                      <div class="container-template-category">
                        <div class="grid-card-row">
                          <TemplateCard
                            v-for="presentation in category.presentations"
                            :key="category.folderId +'_' +presentation.id"
                            v-aha-emit-action="{ template_id: presentation.id }"
                            name="template-card"
                            :presentation="presentation"
                            :where="category.folderName"
                            :version="'template-card-v2'"
                            class="template-category-item template-library w-full"
                          />
                        </div>
                        <div v-if="canUseNewComunityTemplate" class="template-containter_footer text-center mt-4">
                          <button
                            @click="handleCategoryChange({
                              id: category.categoryId,
                              label: category.categoryName,
                            })"
                            class="button-tertiary"
                          >
                            {{ $i18nPresenter.t('See all') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal section -->
    <ModalPublishPresentations
      v-if="showModalPublishPresentations"
      @hide="closeModalPublishPresentations()"
    />
    <TemplatePreviewPopup
      v-if="previewPopup"
      :presentationShareCode="previewShareCode"
      @hide="hidePreviewPopUp()"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'

import InvitationNotifications from '@/components-v2/common/global-notification/InvitationNotifications.vue'
import SearchSection from './template-container/SearchSection.vue'
import CategoryResultSection from './template-container/CategoryResultSection.vue'
import SearchResultSection from './template-container/SearchResultSection.vue'

import OnboardingV3BackArrow from '@/components-v2/common/onboarding/OnboardingV3BackArrow.vue'
import TemplateCard from '@/components-v2/template-library/v2/template-container/TemplateCard.vue'
import TemplateSliderSkeleton from './template-container/TemplateSliderSkeleton.vue'
import TemplatePreviewPopup from '@/components-v2/template/TemplatePreviewPopup.vue'
import ModalPublishPresentations from '@/components-v2/modals/PublishPresentations.vue'
import TemplateNavbar from './template-container/TemplateNavbar.vue'

import EventBus from '@/eventBus'
import utils from '@/util'
import constants from '@/constant'
import SearchApi from '@/api/search'
import CategoryApi from '@/api/category'
import 'swiper/css/swiper.css'

const TEMPLATE_LIBRARY_SECTIONS = {
  DISCOVER: 'Discover',
  SEARCH: 'Search',
  CATEGORY: 'Category',
}

export default {
  components: {
    OnboardingV3BackArrow,
    ModalPublishPresentations,
    SearchSection,
    CategoryResultSection,
    SearchResultSection,
    InvitationNotifications,
    TemplateCard,
    TemplateSliderSkeleton,
    TemplatePreviewPopup,
    Swiper,
    SwiperSlide,
    TemplateNavbar,
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    featuredTemplatesByCategories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModalPublishPresentations: false,
      noResult: false,
      searchText: '',
      isLoadingMore: false,
      isLoadmore: false,
      isSearching: false,
      limit: 20,
      page: 1,
      filteredPresentations: [],
      showLoadMoreAdminPicked: false,
      showLoadMoreNewlyAdded: false,
      categorySelected: {},
      previewPopup: false,
      previewShareCode: '',
      isLoadingCategoryDetail: false,
      selectedCategoryLabel: '',
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('presentationTemplates', [
      'templateAdminPicked',
      'isLoadingTemplateAdminPicked',
      'templateCategories',
      'isLoadingNewlyAdded',
      'getNewlyAddedError',
      'newlyAddedCommunityTemplates',
      'isLoadingTemplates',
      'templateAdminPickedForMobileMini',
      'newlyAddedCommunityTemplatesForMobileMini',
      'templatesError',
      'templateCommunityV2',
    ]),
    ...mapGetters('templates', [
      'getSearchTemplates',
    ]),
    ...mapGetters('featureToggles', ['canUseNewComunityTemplate', 'canUseTemplateLibraryEditorSearch']),
    activeTemplateSection() {
      if (this.$route.query.q) return TEMPLATE_LIBRARY_SECTIONS.SEARCH

      if (this.$route.query.category) return TEMPLATE_LIBRARY_SECTIONS.CATEGORY

      return TEMPLATE_LIBRARY_SECTIONS.DISCOVER
    },
    isSearchSectionActive() {
      return this.activeTemplateSection === TEMPLATE_LIBRARY_SECTIONS.SEARCH
    },
    isCategorySectionActive() {
      return this.activeTemplateSection === TEMPLATE_LIBRARY_SECTIONS.CATEGORY
    },
    isDiscoverSectionActive() {
      return this.activeTemplateSection === TEMPLATE_LIBRARY_SECTIONS.DISCOVER
    },
    activeCategoryId() {
      const { category } = this.$route.query

      return category ? parseInt(category, 10) : null
    },
  },
  watch: {
    $route: {
      handler: function handleChangeRoute(newRoute) {
        if (newRoute.name === 'TemplateLibrary' && newRoute.query.q) {
          // When the route has a query for search, handle the input change
          this.searchText = newRoute.query.q
          this.handleInputChanged()

          this.$nextTick(() => {
            // Scroll to the top after changing the route
            window.scrollTo(0, 0)
          })
        } else if (newRoute.name === 'TemplateLibrary' && newRoute.query.category) {
          // When the route has a query for a category, load the category details
          this.getCategoryDetail(newRoute.query.category)

          this.$nextTick(() => {
            // Scroll to the top after changing the route
            window.scrollTo(0, 0)
          })
        } else {
          // When the route no longer has search or category queries, reset the search state
          this.resetSearchState()
          this.$nextTick(this.initLazyLoad)
        }
      },
      immediate: true,
    },
    filteredPresentations: function handleChangeFilteredPresentations(filteredPresentations) {
      if (filteredPresentations.length) {
        this.$nextTick(this.initLazyLoad)
      }
    },
    canUseNewComunityTemplate: {
      handler: function handleCanUseNewComunityTemplate() {
        this.handleGetTemplatesAction()
        if (this.$route.name === 'TemplateLibrary' && this.$route.query.category) {
          this.getCategoryDetail(this.$route.query.category)
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.resetSearchState()
    this.triggerPreviewPopUp()
    this.triggerQueryByCategory()
    this.triggerQuerySearch()
    await this.handleGetTemplatesAction()
    await this.getNewlyAddedAction()
    await this.getTemplatesAdminPickedAction()
    EventBus.$on('update-library-after-published', (template) => {
      if (template.customThumbnailImage === '_blank') {
        delete template.customThumbnailImage
      }
      this.updatePublishedTemplateInList(template)
    })
  },
  destroy() {
    EventBus.$off('update-library-after-published')
  },
  methods: {
    ...mapActions('presentationTemplates', [
      'getTemplatesAction',
      'getCategoryTemplates',
      'getNewlyAddedAction',
      'getTemplatesAdminPickedAction',
      'updateNewlyAddedAfterPublishAction']),
    handleOpenModalPublishPresentations() {
      this.showModalPublishPresentations = true
    },
    closeModalPublishPresentations() {
      this.showModalPublishPresentations = false
    },
    trackSliderBtn(type) {
      this.clickingToScroll = type
    },
    getSliderOptions(category) {
      // return unique options for each slide
      // avoid using prev/next button on 1 slider also triggers the other sliders
      const { folderId: id } = category
      return {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        spaceBetween: 16,
        noSwiping: false,
        cssMode: false,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          prevEl: `.slider.__prev.--${id}`,
          nextEl: `.slider.__next.--${id}`,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 32,
          },
          960: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 32,
          },
          1280: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16,
          },
          1536: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
          },
          1920: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 32,
          },
          2000: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 32,
          },
        },
        on: {
          setTranslate: _.debounce((translate) => {
            // hack to track scrolling interactions
            // whenever translate changed, it means slider moved
            // either by 1. clicking or 2. scrolling
            // if button is previously clicked, waiting for translate to change
            if (this.clickingToScroll === null) return // initial load, ignore
            if (this.clickingToScroll) {
              this.clickingToScroll = ''
            } else {
              this.translate = translate
            }
          }, 200),
        },
      }
    },
    handleInputChanged: _.debounce(async function handleInputChanged() {
      if (!this.templateCategories || !this.searchText) {
        this.filteredPresentations = []
        this.noResult = false
        this.page = 1
        this.isLoadingMore = false
        this.isLoadmore = false
        return
      }
      this.isLoadingMore = false
      this.isLoadmore = false
      this.page = 1
      this.handleSearchPresentation()
    }, 300),
    async handleSearchPresentation() {
      if (!this.isLoadingMore) {
        this.isSearching = true
      }
      if (!this.searchText) return

      const payload = {
        q: this.searchText,
        page: this.page,
        pageSize: this.limit,
      }

      if (this.canUseTemplateLibraryEditorSearch) {
        await this.$store.dispatch('templates/fetchSearchTemplates', payload)
        const templates = this.getSearchTemplates(this.searchText)

        this.filteredPresentations = this.isLoadingMore ? this.filteredPresentations.concat(templates) : templates
        this.loadmore = templates.length > this.limit
        this.page = templates.length > this.limit ? this.page + 1 : this.page

        utils.mixpanelTracking(constants.eventCategories.TEMPLATE_LIBRARY, 'Search Template', null, null, {
          query: this.searchText,
          showingCount: this.filteredPresentations.length,
        })
      } else {
        try {
          const resp = await SearchApi.searchPresentation(payload)
          if (!this.searchText) return
          if (this.isLoadingMore) {
            this.filteredPresentations = this.filteredPresentations.concat(resp.body.presentations)
          } else {
            this.filteredPresentations = resp.body.presentations
          }
          if (resp.body.presentations.length < this.limit) {
            this.isLoadmore = false
          } else {
            this.page++
            this.isLoadmore = true
          }
          utils.mixpanelTracking(constants.eventCategories.TEMPLATE_LIBRARY, 'Search Template', null, null, {
            query: this.searchText,
            showingCount: this.filteredPresentations.length,
          })
        } catch (e) {
          Sentry.captureException(e)
        } finally {
          this.isSearching = false
        }
      }
      this.noResult = this.filteredPresentations.length === 0
      this.isSearching = false
    },
    triggerQueryByCategory() {
      if (this.$route.query.category && this.$route.query.category.length > 1) {
        this.getCategoryDetail(this.$route.query.category)
      }
    },
    triggerQuerySearch() {
      if (this.$route.query.q && this.$route.query.q.length > 1) {
        this.searchText = this.$route.query.q

        if (!this.searchText) {
        // If no valid search text is provided, reset the search state
          this.resetSearchState()

          return
        }

        // Reset loading indicators and page number for a fresh search
        this.isLoadingMore = false
        this.isLoadmore = false
        this.page = 1
        this.handleSearchPresentation()
      }
    },
    clearSearch() {
    // Reset the search state when the "Clear Search" button is clicked
      this.resetSearchState()
      this.handleInputChanged() // Trigger input change handling after resetting the search state
    },
    triggerPreviewPopUp() {
      if (this.$route.query.preview && this.$route.query.preview.length > 1) {
        this.previewPopup = true
        this.previewShareCode = this.$route.query.preview
      }
    },
    hidePreviewPopUp() {
      this.previewPopup = false
    },
    updatePublishedTemplateInList(template) {
      this.updateNewlyAddedAfterPublishAction(template)
    },
    async getCategoryDetail(id) {
      this.isLoadingCategoryDetail = true

      try {
        const res = await CategoryApi.getCategoryDetail(id)
        this.categorySelected = res
        if (res.id) { // Call api has result, emit event to stop loading
          EventBus.$emit('template-library--category-loaded')
        }
        this.$nextTick(this.initLazyLoad)
      } catch (e) {
        Sentry.captureException(e)
      } finally {
        this.isLoadingCategoryDetail = false
      }
    },
    async loadMore() {
      if (this.isLoadingMore) return
      this.isLoadingMore = true
      this.handleSearchPresentation()
    },
    goToCategoryDetail(category) {
      this.$router.push({
        query: {
          category,
        },
      })
    },
    goToTemplateHome() {
      this.$router.push('/apps/template-library')
    },
    handleCategoryChange(category) {
      this.resetSearchState()
      this.selectedCategoryLabel = category.label

      if (category.id) {
        this.goToCategoryDetail(category.id)
      } else {
        this.goToTemplateHome()
      }
    },
    resetSearchState() {
    // Reset all search-related state variables to their initial values
      this.filteredPresentations = []
      this.noResult = false
      this.searchText = ''
      this.isLoadmore = false
      this.isSearching = false
      this.page = 1
      this.categorySelected = {}
    },
    async handleGetTemplatesAction() {
      if (this.canUseNewComunityTemplate) {
        await this.getCategoryTemplates()
      } else {
        await this.getTemplatesAction()
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/variable.scss";

.result--section {
  @apply relative mb-16 xl:px-6 3xl:px-8 h-full;
  .onboarding__arrow {
    @apply top-4 lg:-left-4 -left-8;
  }
  .categories-list {
    @apply mb-0;
  }
  .title-template-type {
    @apply flex items-center mb-4 text-base xxl:text-xl;
    .icon-template-type {
      margin-right: 9px;
    }
  }

  .title-template-category-container {
    @apply items-baseline;
    .title-item-template-category {
      flex-grow: 1;
    }
    .title-template-see-all {
      @apply flex flex-none  items-center;
      @apply cursor-pointer font-bold text-sm text-primary-90 hover:text-primary-110;
      font-style: normal;
    }
  }
  .slider {
    &.__slider {
      @apply relative;
      min-height: 220px;
      .slider {
        box-shadow: 0px 0px 10px -3px #888888;
      }
    }

    &.__prev,
      &.__next {
        @apply absolute cursor-pointer bg-base-0 rounded-full w-10 h-10;
        @apply flex justify-center items-center hover:text-primary-100;
        top: 48%;
        z-index: 2;

        &.swiper-button-disabled {
          @apply hidden;
        }
        &.hidden {
          display: none;
        }
      }

    &.__prev {
      left: -18px;
      @media (max-width: 767px) {
        left: -14px;
      }
    }

    &.__next {
      right: -18px;
      @media (max-width: 767px) {
        right: -14px;
      }
    }
  }

  .swiper-slide {
    @apply pb-1 mb-4;
  }

  .templates-container {
    @apply px-8;
  }
}
.publish {
  @apply absolute flex-none;
  top: 5.5rem;
  right: 1rem;
}

.template-library-content {
  @apply container xl:max-w-none mx-auto overflow-hidden;
  @apply p-5 md:px-8 xl:pl-10 xl:pr-5 xl:py-8;

  .template-library-content-wrapper {
    @apply grid;

    @media (min-width: 1280px) {
      grid-template-columns: 200px 1fr;
    }
  }

  .template-library-sidebar {
    @apply col-span-12 mb-5 xl:col-auto;
  }

  .template-library-main {
    @apply col-span-12 xl:overflow-hidden xl:col-auto;
  }
}

.grid-card-row {
  @apply grid gap-x-4 gap-y-5 md:gap-8 xl:gap-4 3xl:gap-6;
  @apply grid-cols-1 sm:grid-cols-2;

  @media (min-width: 1400px) {
    grid-template-columns: repeat(auto-fit, minmax($template-card-base-width, 1fr));
  }
}

.template-containter_footer {
  .title-template-see-all {
    @apply inline-block;
    font-style: normal;
  }
  .button-tertiary {
    @apply text-secondary-100 rounded-lg font-bold text-sm px-5 py-3 mb-1;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: #E0E3ED;
    }
    &:active {
      background-color: #D4D7E0;
    }
    &:focus-visible {
      outline: 2px solid #89BEFA;
    }
  }
}

@media (max-width: 960px) {
  .container-template-category {
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    -ms-overflow-style: auto;
  }
}

</style>
